import React, { useContext, useRef } from "react";
import { View, StyleSheet } from "react-native";
import NtDescriptionHightlight from "./NtDescriptionHightlight";
import NtListRow from "../../components/NtListRow";
import NtExtensionTag from "../../components/NtExtensionTag";
import { parseExtension } from "../utils/ExtensionUtils";
import NtModal from "../../components/NtModal";
import NtExtensionUpdateForm from "./NtExtensionUpdateForm";
import UserContext from "../../context/UserContext";
import { usePermission } from "../../hooks/usePermission";
import routes from "../../navigation/routes";
import settings from "../../config/settings";

function NtExtensionItem({ item, columns, onGatewayPress, onUpdate }) {
  const updateModalRef = useRef();
  const context = useContext(UserContext);
  const domain = context?.user?.domain;
  const permission = usePermission(
    settings.permissionTypeEdit,
    routes.extension,
  );

  const renderUpdateForm = () => {
    return (
      <NtModal ref={updateModalRef}>
        <NtExtensionUpdateForm
          item={item}
          onCancel={() => {
            updateModalRef.current?.dismiss();
          }}
          onUpdate={() => {
            updateModalRef.current?.dismiss();
            if (onUpdate) {
              onUpdate();
            }
          }}
          onReset={() => {
            updateModalRef.current?.dismiss();
            if (onUpdate) {
              onUpdate();
            }
          }}
        />
      </NtModal>
    );
  };

  return (
    <View style={styles.container}>
      <NtListRow
        item={item}
        columns={columns}
        renderCustom={(item, column) => {
          if (column == "description") {
            return (
              <NtDescriptionHightlight
                description={item[column]}
                onPress={() => {
                  if (onGatewayPress) {
                    onGatewayPress(item[column]?.split(",")[0]);
                  }
                }}
              />
            );
          } else if (column == "extension") {
            return <NtExtensionTag extension={parseExtension(item[column], domain)} />;
          } else if (column == "toll_allow") {
            return item[column] && item[column] == "t" ? "True" : "False";
          } else if (column == "effective_caller_id_name") {
            return item[column] || parseExtension(item.extension, domain);
          }
        }}
        onActionPress={
          permission
            ? () => {
                updateModalRef.current?.show();
              }
            : null
        }
      />
      {renderUpdateForm()}
    </View>
  );
}

const styles = StyleSheet.create({
  container: {},
});

export default NtExtensionItem;
